export function store(key, val) {
  try { localStorage.setItem(key, JSON.stringify(val)); } catch (e) {}
}
export function load(key) {
  try { const v = localStorage.getItem(key); return v ? JSON.parse(v) : null; } catch (e) { return null; }
}
export function clear(key) {
  try { localStorage.removeItem(key); } catch (e) {}
}

export const K_CONSOLE = "dig_console";
export const K_TEAM = "dig_team";
export const K_PLAYER = "dig_player";
